export enum GamedayBulkSessionState{
    GamedayBulkDetailsAdded,
    GamedayBUlkDetailsNotAdded
}